/**
* @GasInfo.vue
* @Description
* @Author JiShaoHua
* @Date 2022/10/21 15:15
**/
<template>
  <div class="view-tree-table">
    <!-- router-title-box start -->
    <div class="router-title-box" >
      <div class="router-title-item">
        <a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
        <div class="router-title-tit">

          <el-tabs class="whole-page-tabs" v-model="activeName" @tab-click="handleClick" tab-position="top">
            <el-tab-pane label="传感器配置" name="first" clor="red"></el-tab-pane>
            <el-tab-pane label="数据记录" name="second"></el-tab-pane>
            <el-tab-pane label="传感器报警" name="third"></el-tab-pane>
          </el-tabs>

        </div>
      </div>
    </div>
    <!-- router-title-box end -->

    <GasInfoTable v-show="activeName == 'first'" ref="gasInfoTable" :gasTypes="gasTypes"/>
    <GasRecordTable v-show="activeName == 'second'" ref="gasRecordTable" :gasTypes="gasTypes"/>
    <GasAlarmTable v-show="activeName == 'third'" ref="gasAlarmTable" :gasTypes="gasTypes"/>

  </div>
</template>

<script>
import GasInfoTable from "@/components_pages/gas/GasInfoTable.vue";
import GasRecordTable from "@/components_pages/gas/GasRecordTable.vue";
import GasAlarmTable from "@/components_pages/gas/GasAlarmTable.vue";
import ApiGas from "@/request/api-gas";

export default {
  name: "GasInfo",
  components: {
    GasInfoTable,
    GasRecordTable,
    GasAlarmTable
  },
  data() {
    return {
      activeName: 'first',
      gasTypes: []
    }// return
  },// data()
  /**
   * @Description 初始化加载
   * @Date 11:14 2022/10/22
   * @Param
   * @Return
   */
  mounted(){
    // 查询气体类型
    this.searchSensorType();
  },// mounted
  /**
   * @Description 方法定义
   * @Date 15:30 2022/10/21
   * @Param
   * @Return
   */
  methods: {

    /**
     * @Description 查询传感器类型
     * @Date 11:01 2022/10/22
     * @Param
     * @Return
     */
    searchSensorType() {
      this.$request.postJsonRequest(ApiGas.searchSensorTypeApi,{
      }).then(result => {

        this.gasTypes = [];
        if (result.code == 0) {
          this.gasTypes = result.data;
        }
      }).catch(error => {
        console.error('查询传感器类型异常', ApiGas.searchSensorTypeApi, error);
      })
    },
    /**
     * @Description 关闭路由
     * @Date 15:30 2022/10/21
     * @Param
     * @Return
     */
    closeRouter () {
      // 跳转到 首页
      this.$router.replace({path: this.$store.state.homePage}, ()=>{}, ()=>{});
    },// closeRouter

    handleClick(tab, event) {
      if (tab.index == 0) {
        // 请求1
      } else if (tab.index == 1) {
        // 请求2
      } else if (tab.index == 2) {

      }
    },// handleClick

  }// methods
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/system-manager/gas/GasInfo.vue